import cloneDeep from 'lodash/cloneDeep';
import {mapGetters} from 'vuex';

const {parseInt} = globalThis;

export default {
    computed: {
        stateSlideNumber()
        {
            const {slide} = this.$route.params;
            return parseInt(slide, 10) || 1;
        },
        ...mapGetters(['getSlideState'])
    },
    methods: {
        saveState(value, namespace = 'default')
        {
            const {module} = this.$route.params;
            this.$store.commit(
                'setSlideState',
                {module, slide: this.stateSlideNumber, namespace, value}
            );
        },
        getState(namespace = 'default')
        {
            const {module} = this.$route.params;
            const value = this.getSlideState(module, this.stateSlideNumber)[namespace];

            if (typeof value === 'object')
            {
                return cloneDeep(value);
            }
            return value === undefined ? null : value;
        },
        hasState(namespace = 'default')
        {
            const {module} = this.$route.params;
            const value = this.getSlideState(module, this.stateSlideNumber)[namespace];
            return value !== undefined;
        },
        getStateOfSlide(slide, namespace = 'default')
        {
            const {module} = this.$route.params;
            return this.getSlideState(module, parseInt(slide, 10))[namespace];
        }
    }
};
